import PropTypes, { number } from "prop-types"
import React, { useState, useEffect, useRef } from "react"
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    Input,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from "reactstrap"
import { Controller, useForm } from "react-hook-form";
import axios from "axios"
import { MultiSelect } from "primereact/multiselect"
import { InputTextarea } from "primereact/inputtextarea"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { TreeSelect } from "primereact/treeselect";
import { Checkbox } from "primereact/checkbox";
import { Editor } from "primereact/editor";
import Select from 'react-select';
import { Toast } from 'primereact/toast';
//i18n
import { Link, useNavigate } from 'react-router-dom';

import moment from "moment";
import Swal from "sweetalert2";

const JobsEditForm = props => {
    // document.title = "CandidateEditForm | Veltrix - React Admin & CandidateEditForm Template";

    const [jobtitle, setJobtitle] = useState("Web Developer");
    const [workplaceType, setWorkplaceType] = useState(null);
    const workplaceOptions = [
        { name: 'Work from Office (WFO)', code: 'WFO' },
        { name: 'Work from Home (WFH)', code: 'WFH' },
        { name: 'Work from Remote (WFR)', code: 'WFR' }
    ];



    const jobTypeOptions = [
        { name: 'Full Time', code: 'FT' },
        { name: 'Part Time', code: 'PT' },
        { name: 'Contract', code: 'CON' }
    ];

    const [selectedDepartment, setSelectedDepartment] = useState(null);

    const departments = [
        { label: 'Account Finance Team', value: 'Account Finance Team' },
        { label: 'SPG US Staffing', value: 'SPG US Staffing' },
        { label: 'Vitel Development Team', value: 'Vitel Development Team' },
        { label: 'Support Team', value: 'Support Team' },
        { label: 'NOC Team', value: 'NOC Team' },
        { label: 'Digital Marketing Team', value: 'Digital Marketing Team' },
        { label: 'Executive Team', value: 'Executive Team' },
        { label: 'Operations Team', value: 'Operations Team' }
    ];


    const [selectedLocation, setSelectedLocation] = useState(null);

    const locations = [
        { label: 'Hyderabad', value: 'Hyderabad' },
        { label: 'Chennai', value: 'Chennai' },
        { label: 'Mumbai', value: 'Mumbai' },
        { label: 'Bangalore', value: 'Bangalore' },
        { label: 'Delhi', value: 'Delhi' }
    ];


    const [jobStatus, setJobStatus] = useState(null);

    const jobStatusOptions = [
        { label: 'Active', value: 'open' },
        { label: 'InActive', value: 'closed' },
        { label: 'Hold', value: 'hold' },
        { label: 'Blacklisted', value: 'blacklisted' }
    ];

    const [nodes, setNodes] = useState(null);
    
const [recruiterManager, setRecruiterManager] = useState(null);
const [recruiters, setRecruiters] = useState([]);
const [recruiterManagerOptions, setRecruiterManagerOptions] = useState([]);
const [recruiterOptions, setRecruiterOptions] = useState([]);
const [errmsgrecruitermanager, seterrmsgrecruitermanager] = useState("")
const [errmsgrecruiters, seterrmsgrecruiters] = useState("")




    //groups

    const [groups] = useState([
        {
            key: "0",
            label: "Skills",
            children: [
                {
                    key: "0-0",
                    label: "Frontend",
                    children: [
                        { key: "0-0-0", label: "React" },
                        { key: "0-0-1", label: "Angular" },
                        { key: "0-0-2", label: "Bootstrap" },
                    ],
                },
                {
                    key: "0-1",
                    label: "Backend",
                    children: [
                        { key: "0-1-0", label: "Python" },
                        { key: "0-1-1", label: "Java" },
                        { key: "0-1-2", label: "C#" },
                    ],
                },
                {
                    key: "0-2",
                    label: "QA",
                    children: [
                        { key: "0-2-0", label: "Manual" },
                        { key: "0-2-1", label: "Automation" },
                    ],
                },
            ],
        },
    ]);



    //editor

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    };

    const header = renderHeader();

    const [content, setContent] = useState(`<strong>Job Description: </strong><br/>
We are looking for a talented and experienced Web Developer with at least 3 years of experience to join our team. The ideal candidate should have strong expertise in HTML, CSS, and JavaScript and a passion for creating responsive, user-friendly web applications. <br/>
<br/>
<strong>Key Responsibilities:</strong><br/>
Develop and maintain web applications using HTML, CSS, and JavaScript.
Ensure cross-browser compatibility and responsive design.
Optimize web applications for performance and scalability.
Collaborate with designers and back-end developers to implement UI/UX improvements.
Debug and troubleshoot website issues and implement solutions.
Stay updated with the latest web development trends and best practices.
<br/>
<br/>
<strong>Required Skills:</strong><br/>
Strong proficiency in HTML, CSS, and JavaScript.
Experience with CSS frameworks (e.g., Bootstrap, Tailwind CSS).
Knowledge of JavaScript frameworks (e.g., React, Vue, or Angular) is a plus.
Understanding of responsive web design and cross-browser compatibility.
Familiarity with version control systems (e.g., Git).
Strong problem-solving and debugging skills.
<br/>
<br/>
<strong>Preferred Qualifications:</strong>
<br/>
Experience with RESTful APIs and AJAX.
Basic understanding of SEO best practices.
Familiarity with CMS platforms like WordPress or Shopify.
Experience with task runners/build tools like Webpack, Gulp, or npm.`);
    const maxWords = 500;

    // Function to calculate word count
    const calculateWordCount = (text) => {
        const words = text
            .trim()
            .replace(/<[^>]*>/g, "") // Remove HTML tags
            .split(/\s+/); // Split by whitespace
        return words.filter((word) => word).length; // Filter out empty words
    };

    // Current word count
    const currentWordCount = calculateWordCount(content);

    // Handle editor input
    const handleEditorChange = (e) => {
        const text = e.htmlValue || ""; // Get the HTML content
        if (calculateWordCount(text) <= maxWords) {
            setContent(text); // Only update content if within word limit
        }
    };

    //skills


    const [skillsOptions, setSkillsOptions] = useState([]);
    const [selectedprimarySkills, setselectedprimarySkills] = useState([]);

    const [selectedSkillsSecondary, setselectedSkillsSecondary] = useState([]);

    const getskills = async () => {
        try {

            const response = await axios.get(`/api/v1/get-all-skills/`, {
            });
            console.log(response.data)
            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((workv) => ({
                name: workv.skill_name,
                id: workv.skill_id,
            }));
            setSkillsOptions(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    // Handle Secondary Skills Selection
    const handleSecondarySkillsChange = (selectedOptions) => {
        setSelectedSecondarySkills(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };



    // screening questions

    const [isQualificationRequired1, setIsQualificationRequired1] = useState(false);


    const [question1, setQuestion1] = useState("Html");
    const [answer1, setAnswer1] = useState("3");



    // toast msg

    const toast = useRef(null);

    const showMessage = () => {
        toast.current.show({ severity: 'info', summary: 'Job ID 3048 Saved' });
    };
    const showCancel = () => {
        toast.current.show({ severity: 'error', summary: 'Cancelled', life: 3000 });
    }

    // sample data starts
    const [category, setCategory] = useState("Frontend");
    const [group, setGroup] = useState("Html, CSS");

    // sample data ends



    const [menu, setMenu] = useState(false)
    const { register, handleSubmit, reset, trigger, clearErrors, formState: { errors }, setError, setValue, getValues, control } = useForm();
    const toggle = () => {
        setMenu(!menu)
    }
    // document.title = "CandidateEditForm | Veltrix - React Admin & CandidateEditForm Template";

    const [selectedCity, setSelectedCity] = useState(null)


    const [totalExperience, setTotalExperience] = useState(null);

    const [address, setAddress] = useState();


    const [otherSkillsval, setotherSkillsval] = useState([])
    const [secondarySkillsval, setsecondarySkillsval] = useState([])
    const [primarySkillsvalu, setprimarySkillsvalu] = useState([])


    // education

    const [educationDetails, setEducationDetails] = useState([]);
    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const [newEducation, setNewEducation] = useState({
        degree: '',
        institution: '',
        year: '',
        endYear: '',
        endMonth: '',
        grade: '',
    });

    // Add new education details to the table
    const handleAddEducation = () => {
        if (
            newEducation.degree.trim() &&
            newEducation.institution.trim() &&
            newEducation.year.trim() &&
            newEducation.grade.trim()
        ) {
            setEducationDetails([...educationDetails, { ...newEducation }]);
            setNewEducation({ degree: '', institution: '', year: '', grade: '' });
            setIsDialogVisible(false);
        } else {
            alert("Please fill all fields.");
        }
    };

    const handleSave1 = () => {
        if (editIndex !== null) {
            // Update existing record
            const updatedExperiences = [...educationDetails];
            updatedExperiences[editIndex] = newEducation;
            setEducationDetails(updatedExperiences);
            setEditIndex(null);
        } else {
            // Add new record
            setEducationDetails([...educationDetails, newEducation]);
        }
        setNewEducation({
            degree: " ",
            website: " ",
            jobTitle: " ",
            fromDate: null,
            toDate: null,
            description: " ",
        });
        setIsDialogVisible(false);
    };

    const handleSavedocument = () => {
        if (editIndex1 !== null) {
            // Update existing record
            const updatedExperiences = [...documents];
            updatedExperiences[editIndex] = documentvalu;
            setDocuments(updatedExperiences);
            setEditIndex1(null);
        } else {
            // Add new record
            setDocuments([...documents, documentvalu]);
        }
        setdocumentvalu({
            degree: " ",
            website: " ",
            jobTitle: " ",
            fromDate: null,
            toDate: null,
            description: " ",
        });
        setDisplayDialog(false);
    };

    const [documentvalu, setdocumentvalu] = useState({
        file: "",
        subject: "",
        selectedDocument: ""
    })


    const handleInputChange1 = (key, value) => {
        setdocumentvalu((prev) => ({
            ...prev,
            [key]: value,
        }));
    };


    const years = Array.from({ length: 50 }, (_, i) => {
        const year = new Date().getFullYear() - i;
        return { label: year.toString(), value: year.toString() };
    });

    const geteditvaluescandidates = async (id) => {
        try {
            const response = await axios.get(`/api/v1/jobs/${id}/`, {

            });
            if (response.data) {
                let results = response.data;
                setHiringManager(results.hiring_manager || null);

                setstatusjob(results.status);
                setTimeout(() => {
                    // setEditFormValues(results);
                    setValue("job_id", results.job_number);
                    setValue("job_title", results.job_title);
                    setValue("status", results.status);
                    // setValue("openingss", results.openings);
                    // setValue("required_experience", results.required_experience);
                    // const startdateObject = new Date(results.job_posting_date);
                    // setValue("job_posting_date", startdateObject);
                    // const enddateObject = new Date(results.job_closing_date);
                    // setValue("job_closing_date", enddateObject);

                    setValue("department", results.department);
                    setValue("timetohire", results.time_to_hire_days);
                    setdepartitemsval(results.department)
                    setHiringManager(results.hiring_manager)
                    setRecruiterManager(results.recruiting_manager)
                    setRecruiters(results.recruiters || [])
                    setSelectedCategoryKey(results.category)
                    setSelectedGroupKey(results.groups)
                    // setSelectedGroupKey(results.groups_name)
                    setjobworkspace(results.workplace_types)
                    setjobtype(results.job_type)
                    setDescription(results.job_notes)
                    setOpeningss(results.openings)
                    setExperience(results.required_experience ? results.required_experience : "")
                    setSelectedCompany(results.company_id);
                    setOpenings(results.openings);
                    setMaxSalary(results.salary_max);
                    setMinSalary(results.salary_min);
                    setJobLocation(results.location);
                    setText(results.job_description)
                    setSelectedJobFunction(results.job_function)
                    setSelectedSeniority(results.seniority)
                    setselectedprimarySkills(results.required_skills)

                    setSecondarySkills(results.required_skills || []);
                    setselectedSkillsSecondary(results.preferred_skills || []);
                    setOtherSkills(results.other_skills || []);
                    setcreatedBy(results.created_by_name)
                    let startjobdate = results.job_start_date ? moment(results.job_start_date, "YYYY-MM-DD").toDate() : null;
                    setJobStartDate(startjobdate)

                    let endjobdate = results.job_end_date ? moment(results.job_end_date, "YYYY-MM-DD").toDate() : null;
                    setJobEndDate(endjobdate);

                    let updatejobdate = results.updated_at ? moment(results.updated_at, "YYYY-MM-DD").toDate() : null;
                    seteditDatejob(updatejobdate);

                    let createdjobdate = results.created_at ? moment(results.created_at, "YYYY-MM-DD").toDate() : null;
                    setjobCreate(createdjobdate);

                    let actualjobdate = results.actual_end_date ? moment(results.actual_end_date, "YYYY-MM-DD").toDate() : null;
                    setjobActualEnddate(actualjobdate);


                    const screeningQuestions = results.screening_questions.map((item) => ({
                        section1: item.question_text,
                        idealAnswer: item.ideal_answer,
                        qualification: item.must_have_qualification || false,
                        skills: item.skill,
                        question_id: item.question_id,
                        is_deleted: false,
                        haveError: false,
                    }));

                    setFormValues(screeningQuestions);

                }, 1000);

                // let newArray = [];
                // results.screening_questions.map((item) => {
                //     let obj = {
                //         section1: item.question_text,
                //         idealAnswer: item.ideal_answer,
                //         question_id: item.question_id,
                //         qualification: item.must_have_qualification,
                //         skills: item.skill,
                //     };
                //     newArray.push(obj);

                // });

                // setFormValues([...newArray]);




            }
        } catch (error) {

        }
    };

    // system fields
    const handleUpload = (e) => {
    };

    const [selectedJobFunction, setSelectedJobFunction] = useState(null);
    const [jobFunctions, setjobFunctions] = useState([])

    const [selectedSeniority, setSelectedSeniority] = useState(null);
    const [seniorityLevels, setseniorityLevels] = useState([]);


    const getfunctionview = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-jobfunction-type/`, {

            });

            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((jobtypes) => ({
                name: jobtypes.jobfunction_type,
                id: jobtypes.id,
            }));
            setjobFunctions(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };


    const getsentrory = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-seniority-level/`, {

            });

            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((sen) => ({
                name: sen.seniority_level,
                id: sen.id,
            }));
            setseniorityLevels(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };
    useEffect(() => {
        getsentrory()
        getfunctionview()

    }, [])




    // screening questions
    const [queVisible, setQueVisible] = useState(false);
    const [isQualificationRequired, setIsQualificationRequired] = useState(false);
    const [questionsData, setQuestionsData] = useState([]);
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");

    // Handle form submission
    const handleCreate = () => {
        // Add the new question data to the DataTable
        const newQuestion = {
            question: question,
            answer: answer,
            qualificationRequired: isQualificationRequired ? "Yes" : "No"
        };
        setQuestionsData([...questionsData, newQuestion]);

        // Reset the form fields
        setQuestion("");
        setAnswer("");
        setIsQualificationRequired(false);

        // Close the dialog
        setQueVisible(false);
    };


    // screening questions
    const [questions, setQuestions] = useState([]);

    // Function to add a new question card
    const handleAddQuestion = () => {
        setQuestions([
            ...questions,
            { skill: "", experience: "", qualification: false },
        ]);
    };

    // Function to update a question
    const handleQuestionChange = (index, field, value) => {
        const updatedQuestions = [...questions];
        updatedQuestions[index][field] = value;
        setQuestions(updatedQuestions);
    };

    // Function to remove a question card
    const handleRemoveQuestion = (index) => {
        const updatedQuestions = questions.filter((_, i) => i !== index);
        setQuestions(updatedQuestions);
    };

    //edit address
    const [visible, setVisible] = useState(false);
    const [street1, setStreet1] = useState('');
    const [street2, setStreet2] = useState('');
    // const [selectedCity, setSelectedCity] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [postalCode, setPostalCode] = useState('');
    const [selectedLabel, setSelectedLabel] = useState(null);
    const [selectedLabel1, setSelectedLabel1] = useState(null);



    const [basicimp, setbasicimp] = useState()
    const [basictittle, setbasictittle] = useState('');
    const [basicfirst, setbasicfirst] = useState('');
    const [basiclast, setbasiclast] = useState('');
    const [basicmiddle, setbasicmiddle] = useState('');

    const updateAddress = () => {
        // setAddress(`${street1}  ${street2} ${postalCode}`.trim());
    };
    useEffect(() => {
        const updatedAddress = [street1, street2, postalCode, selectedState?.name, selectedCity?.name, selectedCountry?.name, selectedLabel?.name, postalCode].filter(Boolean);
        setAddress(updatedAddress);

        const updatenamesbasic = [basictittle, basicfirst, basicmiddle, basiclast].filter(Boolean).join(" ");
        setbasicimp(updatenamesbasic)

    }, [street1, street2, postalCode, selectedState, selectedCity, selectedCountry, selectedLabel, postalCode, basictittle, basicfirst, basicmiddle, basiclast]);





    const [jobworkspace, setjobworkspace] = useState(null);
    const [jobworkspaceview, setjobworkspaceview] = useState([]);

    const [jobtype, setjobtype] = useState(null);
    const [jobjobtypeview, setjobjobtypeview] = useState([]);




    const getworkspace = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-workplace-type/`, {

            });
            console.log(response.data)
            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((workv) => ({
                name: workv.workplace_type,
                id: workv.id,
            }));
            setjobworkspaceview(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    const getjoptype = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-Job-types/`, {

            });

            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((jobtypes) => ({
                name: jobtypes.job_type,
                id: jobtypes.id,
            }));
            setjobjobtypeview(transformedData);

        }
        catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    const getDepartments = async () => {

        try {
            const response = await axios.get(`/api/v1/get-all-departments/`, {

            });
            if (response.data) {

                const transformedData = response.data.results.map((dept) => ({
                    name: dept.name,
                    id: dept.department_id,
                }));
                setdepartitems(transformedData);
            }
        } catch (error) {

        }
    };


    useEffect(() => {
        getworkspace()
        getjoptype()
    }, [])



    const [jobType, setJobType] = useState(null);

    const [jobLocation, setJobLocation] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [jobLocations, setjobLocations] = useState([])
    const [companies, setcompanies] = useState([])

    const getcity = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-cities/`, {

            });
            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((city) => ({
                name: city.name,
                id: city.city_id,
            }));
            setjobLocations(transformedData);

        }
        catch (error) {
        }
    };
    const getCompany = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-companies/`, {

            });
            // Transform data if needed to match the Dropdown format
            const transformedData = response.data.results.map((company) => ({
                name: company.company_name,
                id: company.company_id,
            }));
            setcompanies(transformedData);


        }
        catch (error) {
        }
    };
    useEffect(() => {
        getcity()
        getCompany()
    }, [])


    const [openings, setOpenings] = useState(null);

    const [minSalary, setMinSalary] = useState(null);
    const [maxSalary, setMaxSalary] = useState(null);



    const [statusjob, setstatusjob] = useState(null)
    const [jobStatusview, setjobStatusview] = useState([]);

    const getjobstatus = async () => {

        try {
            const response = await axios.get(`/api/v1/get-all-Job-status/`, {});
            const transformedData = response.data.results.map((jobstu) => ({
                name: jobstu.job_status,
                id: jobstu.id,
            }));
            setjobStatusview(transformedData);
        } catch (error) {

        }
    };

    useEffect(() => {
        getjobstatus()
    }, [])



    // categories
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
    const [selectedgroupKey, setselectedgroupKey] = useState(null);

    const [createdBy, setcreatedBy] = useState(null);
    const [categoriesitem, setcategoriesitem] = useState([])
    const [selectedCategoryKey, setSelectedCategoryKey] = useState();
    const [groupitem, setgroupitem] = useState([])
    const [selectedGroupKey, setSelectedGroupKey] = useState(null);
    const [text, setText] = useState('');
    const [jobStartDate, setJobStartDate] = useState(null);
    const [jobCreate, setjobCreate] = useState(null);
    const [jobEndDate, setJobEndDate] = useState(null);
    const [primarySkillsview, setprimarySkillsview] = useState(null);
    const [primarySkillsget, setprimarySkillsget] = useState([]);
    const getMinEndDate = () => {
        if (!jobStartDate) return null;
        const minDate = new Date(jobStartDate);
        minDate.setDate(minDate.getDate() + 1);
        return minDate;
    };

    // Calculate time-to-hire when dates change
    useEffect(() => {
        if (jobStartDate && jobEndDate) {
            const startDate = new Date(jobStartDate);
            const endDate = new Date(jobEndDate);
            const timeDiff = endDate.getTime() - startDate.getTime();
            const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
            
            if (daysDiff > 0) {
                setValue("timetohire", daysDiff);
            }
        } else {
            setValue("timetohire", "");
        }
    }, [jobStartDate, jobEndDate, setValue]);
    const formatCategories = (categories) => {
        return categories.map((cat) => ({
            key: String(cat.category_id),
            label: cat.name,
            children: cat.subcategories ? formatCategories(cat.subcategories) : [],
        }));
    };
    const getcategoriesitemvalues = async () => {

        try {
            const response = await axios.get(`/api/v1/get-all-categories/`, {

            });

            if (response.data && response.data.results) {
                const formatted = formatCategories(response.data.results);
                setcategoriesitem(formatted);
            }
        } catch (error) {

        }
    };

    const formatGroups = (groups) => {
        return groups.map((grp) => ({
            key: String(grp.group_id),
            label: grp.name,
            children: grp.subgroups ? formatGroups(grp.subgroups) : [],
        }));
    };
    const getgroupsitemsub = async (category_ids) => {

        try {
            const response = await axios.get(`/api/v1/get-all-groups/`, {

            });
            if (response.data && response.data.results) {
                const formattedGroups = formatGroups(response.data.results);
                setgroupitem(formattedGroups);
            }

        } catch (error) {

        }
    };

    const handleCategoryChange = (e) => {
        const category_id = e.value;
        setSelectedCategoryKey(category_id);
    };
    useEffect(() => {

        getgroupsitemsub();

    }, []);

    useEffect(() => {
        getcategoriesitemvalues()
        getskills()

    }, [])


    const [primarySkills, setPrimarySkills] = useState();
    const [secondarySkills, setSecondarySkills] = useState(null);
    const [otherSkills, setOtherSkills] = useState();



    const [dateAvalibility, setDateAvalibility] = useState(null);
    const [dob, setDob] = useState(null);


    const [EmployeeRec, setEmployeeRec] = useState("  ")

    //  work experience variables start

    const [workExperiences, setWorkExperiences] = useState([]);

    const [editIndex1, setEditIndex1] = useState(null);
    const [editIndex, setEditIndex] = useState(null);


    const [selectedStatus1, setSelectedStatus1] = useState(null);  // Renamed to setSelectedStatus1
    const [subject, setSubject] = useState('');
    const [file, setFile] = useState(null);
    const [documents, setDocuments] = useState([]);

    const navigate = useNavigate();

    const handleSaveClick = () => {
        setMerge(true);

    };
    const [pathSegment, setPathSegment] = useState(null);
    useEffect(() => {
        const url = new URL(window.location.href); // Get the current URL
        // const pathParts = url.pathname.split('/'); // Split the pathname into parts
        // const lastSegment = pathParts[pathParts.length - 1]; // Get the last part of the path

        // setPathSegment(lastSegment); // Set the last segment to state

        const candidateIdFromQuery = url.searchParams.get("job_id");
        if (candidateIdFromQuery) {
            setPathSegment(candidateIdFromQuery);
            geteditvaluescandidates(candidateIdFromQuery);
        }

    }, []);



    const [merge, setMerge] = useState(false);
    const footerContent = (
        <div className="d-flex justify-content-center">
            <button type="button" onClick={() => {
                navigate('/all_active_employees');

            }} class="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2">Yes</button>

            <button type="button" onClick={() => {
                navigate('/all_active_employees');

            }} class="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2">No</button>
        </div>
    );

    const [experience, setExperience] = useState("");
    const [openingss, setOpeningss] = useState("");

    const [timetohire, settimetohire] = useState(null);
    const [jobActualEnddate, setjobActualEnddate] = useState(null);
    const [editDatejob, seteditDatejob] = useState(null);
    const [description, setDescription] = useState("")
    const [jobtypeerr, setjobtypeerr] = useState("")
    const [errorjobs, seterrorjobs] = useState("");
    const [hiringManagerError, setHiringManagerError] = useState("");



    const onSubmit = async (data) => {

        if (!jobtype) {
            setjobtypeerr("job type required")
            return
        }
        if (!hiringManager) {
            setHiringManagerError("Hiring Manager is required");
            return;
        } else {
            setHiringManagerError("");
        }
        if (!recruiterManager) {
            seterrmsgrecruitermanager("Recruiter Manager is required");
            return;
        } else {
            seterrmsgrecruitermanager("");
        }
        console.log(data,)
        const formattedFromDate = moment(jobStartDate).format("YYYY-MM-DD");
        const formattedtoDate = moment(jobEndDate).format("YYYY-MM-DD");

        const jobActualEnddateDate = moment(jobActualEnddate, "YYYY-MM-DD").format("YYYY-MM-DD");
        let req = {};
        try {

            if (data.job_title) {
                req.job_title = data.job_title;
            }
            if (hiringManager) {
                req.hiring_manager = hiringManager;
            }
            if (recruiterManager) {
                req.recruiting_manager = recruiterManager;
            }
            req.recruiters = recruiters;
            if (departitemsval) {
                req.department = departitemsval;
            }
            if (jobCreate) {
                const jobCreateFromDate = moment(jobCreate).format("YYYY-MM-DD");
                req.created_at = jobCreateFromDate;
            }
            if (jobStartDate) {
                const formattedFromDate = moment(jobStartDate).format("YYYY-MM-DD");
                req.job_start_date = formattedFromDate;
            }

            if (jobEndDate) {
                const formattedToDate = moment(jobEndDate).format("YYYY-MM-DD");
                req.job_end_date = formattedToDate;
            }
            if (data.timetohire) {
                req.time_to_hire_days = data.timetohire;
            }
            if (jobActualEnddate) {
                const actualFromDate = moment(jobActualEnddate).format("YYYY-MM-DD");
                req.actual_end_date = actualFromDate;
            }


            if (statusjob) {
                req.status = statusjob;
            }
            if (openingss) {
                req.openings = openingss;
            }
            if (experience) {
                req.required_experience = experience;
            }
            if (selectedCompany) {
                req.company_id = selectedCompany;
            }
            if (jobLocation) {
                req.location = jobLocation;
            }
            if (jobworkspace) {
                req.workplace_types = jobworkspace;
            }
            if (jobtype) {
                req.job_type = jobtype;
            }
            if (minSalary) {
                req.salary_min = minSalary;
            }
            if (maxSalary) {
                req.salary_max = maxSalary;
            }
            if (description) {
                req.job_notes = description;
            }

            if (selectedSkillsSecondary) {
                req.preferred_skills = selectedSkillsSecondary;
            }
            if (selectedprimarySkills) {
                req.required_skills = selectedprimarySkills;
            }
            if (selectedJobFunction) {
                req.job_function = selectedJobFunction;
            }
            if (selectedSeniority) {
                req.seniority = selectedSeniority;
            }
            if (selectedCategoryKey) {
                req.category = Number(selectedCategoryKey);
            }
            if (selectedGroupKey) {
                req.groups = selectedGroupKey;

            }
            if (text) {
                req.job_description = text;
            }
            const validQuestions = formValues.filter(
                (question) =>
                    !question.is_deleted &&
                    (question.section1 || question.skills || question.idealAnswer || question.qualification)
            );

            if (validQuestions.length > 0) {
                req.screening_questions = validQuestions.map((question) => ({
                    question_text: question.section1,
                    question_id: question.question_id || undefined,
                    is_deleted: question.is_deleted,
                    skill: question.skills,
                    ideal_answer: question.idealAnswer,
                    must_have_qualification: question.qualification || false,
                }));
            }

            const endpoint = pathSegment
                ? `/api/v1/jobs/${pathSegment}/` // Edit existing
                : `/api/v1/jobs/`;              // Create new

            const method = pathSegment ? 'patch' : 'post';
            const errorCode = pathSegment ? 200 : 201;

            const response = await axios[method](endpoint, req);
            if (response.status === errorCode) {
                // triggerAlert('success', 'Success', 'Candidate Updated Successfully.');
                navigate('/allactive-jobs');
            } else {

            }
        } catch (error) {
            const responseData = error?.response?.data || {};
            const fieldErrors = responseData.errors;
            const fieldNames = Object.keys(fieldErrors || {});
            const firstField = fieldNames[0];
            const firstMessage = Object.values(fieldErrors || {}).flat()[0]
                || responseData.error
                || "Please correct the highlighted fields.";
            const fieldMessages = {
                job_title: "Job title is required.",
                company_id: "Please select a company.",
                reporting_manager: "Reporting manager is required. Please select a reporting manager.",
                hiring_manager: "Please select a valid hiring manager.",
                recruiting_manager: "Please select a valid recruiting manager.",
                job_end_date: "Please enter a valid job end date.",
            };
            const displayMessage = fieldMessages[firstField] || firstMessage;

            if (firstField === "hiring_manager") {
                setHiringManagerError(displayMessage);
            } else if (firstField === "recruiting_manager" || firstField === "recruiter_manager") {
                seterrmsgrecruitermanager(displayMessage);
            } else {
                const formField = firstField === "job_end_date" ? "jobEndDate" : firstField;
                if (formField) {
                    setError(formField, { type: "server", message: displayMessage });
                }
            }

            seterrorjobs(displayMessage);
            await Swal.fire({
                title: "Error!",
                text: displayMessage,
                icon: "error",
                confirmButtonText: "OK",
            });

        } finally {
            // setIsLoading(false);
            // reset();

        }


    };


    const getHiringManagers = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-hiring-managers/?status=Active`);
            const transformedData = response?.data?.results?.map((hm) => ({
                name: `${hm.first_name} ${hm.middle_name || ''} ${hm.last_name || ''}`.trim(),
                id: hm.id,
            }));
            setHiringManagers(transformedData);
        } catch (error) {
            setHiringManagers([]);
        }
    };

    const getRecruiterManagers = async () => {
        try {
            const response = await axios.get(`/api/v1/users/recruiting-managers/`);
            const transformedData = response?.data?.results?.map((rm) => ({
                name: rm.full_name,
                id: rm.id,
            }));
            setRecruiterManagerOptions(transformedData);
        } catch (error) {
            setRecruiterManagerOptions([]);
        }
    };

    const getRecruiterOptions = async () => {
        try {
            const response = await axios.get(`https://qaatsapi.pranathiss.com/api/v1/users/recruiters/`);
            const transformedData = response?.data?.results?.map((r) => ({
                name: r.full_name,
                id: r.id,
            }));
            setRecruiterOptions(transformedData);
        } catch (error) {
            console.error('Error fetching recruiters:', error);
            setRecruiterOptions([]);
        }
    };



    const getgroupsitem = async () => {

        try {
            const response = await axios.get(`/api/v1/skills/`, {

            });
            if (response.data && response.data.results) {
                const treeData = response.data.results;
                setotherSkillsval(treeData);
                setsecondarySkillsval(treeData)
                setprimarySkillsvalu(treeData)
            }

        } catch (error) {

        }
    };
    useEffect(() => {
        getgroupsitem()



    }, [])

    const [hirringdata, sethirringdata] = useState([])
    const [departitems, setdepartitems] = useState([])
    const [departitemsval, setdepartitemsval] = useState(null)

    const [hiringManager, setHiringManager] = useState(null);
    const [hiringManagers, setHiringManagers] = useState([])




    useEffect(() => {
        getHiringManagers()
        getRecruiterManagers()
        getRecruiterOptions()
        getDepartments()
    }, []);


    /////////////////////

    const [formValues, setFormValues] = useState([{ section1: "" }]);

    const [questionError, setQuestionError] = useState(null);

    const handleChange = (index, field, value) => {
        // Clone the current form values
        const newFormValues = [...formValues];

        // Ensure the object at the specified index exists
        if (newFormValues[index]) {
            newFormValues[index][field] = value; // Update the field
            if (field === "qualification" && typeof value === "string") {
                value = value.trim();  // Only trim if it's a string
            }// Set error flag
            setFormValues(newFormValues); // Update the state
        } else {
        }
    };
    let addFormFields = () => {
        setQuestionError('');
        setFormValues([...formValues, { section1: "", idealAnswer: "", qualification: false, skills: "", is_deleted: false, haveError: false }]);
        // console.log(formValues,'formValues on add click')
    };
    const removeFormFields = async (index, question_id) => {
        // new item (not saved yet)
        if (!question_id) {
            const newFormValues = [...formValues];
            newFormValues.splice(index, 1);
            setFormValues(newFormValues);
            return;
        }

        // existing (saved) item
        try {
            const response = await axios.delete(`/api/v1/screening-questions/${question_id}/`);
            if (response) {
                // <- remove it from local state immediately
                const updatedValues = [...formValues];
                updatedValues.splice(index, 1);
                setFormValues(updatedValues);
                console.log(updatedValues, 'formValues after delete')
                return

                // Optional: refresh from api
                // getAllActive(pageState.page, pageState.rows);

                setSuccessAlert(true);
                setSmShow(false);
            }
        } catch (err) {
            console.error("Error deleting field:", err);
        }
    };

    const removeFormFields1 = (i) => {
        const newFormValues = [...formValues];
        newFormValues[i].is_deleted = true; // ✅ Correct key
        setFormValues(newFormValues);
    };


    return (
        <React.Fragment>
            <div className="page-content create-ajob">
                <Container fluid>
                    <div className="page-title-box">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <h1 className="page-title">Edit a Job</h1>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item active">
                                        Create a job with essential details, including the job description, hiring information, system fields, and screening questions.
                                    </li>
                                </ol>
                            </Col>
                            {/* <Col md={6}>
                                <div className="d-flex justify-content-end">
                                    <Toast ref={toast} />
                                  
                                    <Link to="/allactive-jobs">
                                        <button type="submit" class="btn btn-success me-2" >  <i className="pi pi-save me-1"></i> Save </button>

                                    </Link>

                                    <Link to="/allactive-jobs">
                                        <Button
                                            color="primary"
                                            className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                                        >
                                            <i className="pi pi-times me-1"></i>
                                            Cancel
                                        </Button>
                                    </Link>

                                </div>

                            </Col> */}
                        </Row>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            {/* 1st Row */}
                            <Col xl={4}>
                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Basic Information</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="jobId">Job Number<span className="text-danger">*</span></label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <InputText id="job_id" className="w-full" readOnly {...register("job_id")} />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="integer" className=" block mb-2">
                                                                JobTitle <span className="text-danger">*</span>
                                                            </label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <InputText
                                                                id="job_title"
                                                                className="w-full"
                                                                {...register("job_title", {
                                                                    required: "Job Title is required",
                                                                    pattern: {
                                                                        value: /^[A-Za-z-\s&]+$/,
                                                                        message: "Only alphabets and spaces allowed."
                                                                    }
                                                                })}
                                                                onKeyUp={() => trigger("job_title")}
                                                            />
                                                            {errors.job_title && (
                                                                <small className="form-text text-danger">{errors.job_title.message}</small>
                                                            )}
                                                        </Col>
                                                    </Row>

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="status">Job Status</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <div className="card flex justify-content-center mb-0">
                                                                <Dropdown
                                                                    value={statusjob}
                                                                    onChange={(e) => { setstatusjob(e.value) }}
                                                                    options={jobStatusview}
                                                                    optionLabel="name"
                                                                    optionValue="id"
                                                                    filter
                                                                    filterPlaceholder="Search "
                                                                    className="w-full activejobdrop"
                                                                    placeholder="Enter Job Status..."
                                                                />

                                                            </div>

                                                            {/* <Dropdown
                                                                id="jobStatusval"
                                                                value={jobStatusval}
                                                                onChange={(e) => setjobStatusval(e.value)}
                                                                options={jobStatusview}
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                filter
                                                                filterPlaceholder="Search Location"
                                                                className="w-full activejobdrop"
                                                                placeholder="Enter job..."
                                                            /> */}
                                                            {/* <Dropdown
                                                                className="w-full"
                                                                editable
                                                                id="status"
                                                                options={jobStatusOptions}
                                                                placeholder="Select Job Status"
                                                                {...register("status", {
                                                                    required: "Job Status is required"
                                                                })}
                                                                onChange={(e) => setValue("status", e.value)}
                                                                value={getValues("status")}
                                                            />
                                                            {errors.status && (
                                                                <small className="form-text text-danger">{errors.status.message}</small>
                                                            )} */}
                                                        </Col>
                                                    </Row>

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="currentSalary" className="block mb-2">
                                                                No of Openings
                                                            </label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <InputText
                                                                value={openingss || ''}
                                                                onChange={(e) => {
                                                                    const val = e.target.value;
                                                                    if (val === '' || (/^[0-9]+$/.test(val) && parseInt(val) >= 0)) {
                                                                        setOpeningss(val === '' ? null : parseInt(val));
                                                                    }
                                                                }}
                                                                onKeyPress={(e) => {
                                                                    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                className="w-full activejobdrop"
                                                                placeholder="Enter number of openings"
                                                            />
                                                        </Col>

                                                    </Row>

                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="required_experience" className="block mb-2">
                                                                Experience Required <span className="text-danger">*</span>
                                                            </label>
                                                        </Col>
                                                        <Col xl={9}>
                                                        <InputNumber
            id="experience"
            value={experience}
            onValueChange={e => {
                const val = e.value;
                if (val === null || val === undefined || val === "") {
                    setExperience("");
                } else if (val >= 0) {
                    setExperience(val);
                } else {
                    setExperience(0); // Reset to 0 if negative
                }
            }}
            min={0} // Prevents negative values in the UI
            useGrouping={false}
            className="w-full activejobdrop"
            placeholder="e.g. 3-6 years"
        />
                                                            {/* <InputNumber
                                                                id="experience"
                                                                value={experience}
                                                                // onValueChange={(e) => {
                                                                //     const value = e.value;
                                                                //     if (value >= 0) {
                                                                //         setExperience(value);
                                                                //     } else {
                                                                //         setExperience(null);
                                                                //     }
                                                                // }}
                                                                onChange={e => setExperience(e.target.value)}
                                                                min={0}
                                                                useGrouping={false}  // disables commas
                                                                className="w-full activejobdrop"
                                                            /> */}
                                                        </Col>
                                                    </Row>


                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="integer" className=" block"                                                                    >
                                                                Job Start Date
                                                            </label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <Calendar
                                                                id="jobStartDate"
                                                                value={jobStartDate}
                                                                // onChange={(e) => setJobStartDate(e.value)}
                                                                onChange={(e) => {
                                                                    setJobStartDate(e.value);
                                                                    // Optional: Reset end date if it becomes invalid
                                                                    if (jobEndDate && e.value && jobEndDate <= e.value) {
                                                                        setJobEndDate(null);
                                                                    }
                                                                }}
                                                                minDate={new Date()}
                                                                dateFormat="yy-mm-dd"
                                                                placeholder="YYYY-MM-DD"
                                                                showIcon
                                                                className="w-full activejobdrop"
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label
                                                                htmlFor="integer"
                                                                className=" block"
                                                            >
                                                                Job End Date
                                                            </label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <Calendar
                                                                id="jobEndDate"
                                                                value={jobEndDate}
                                                                onChange={(e) => setJobEndDate(e.value)}
                                                                minDate={getMinEndDate()}
                                                                disabled={!jobStartDate}
                                                                dateFormat="yy-mm-dd"
                                                                placeholder="YYYY-MM-DD"
                                                                className="w-full activejobdrop"
                                                                showIcon
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label
                                                                htmlFor="integer"
                                                                className=" block"
                                                            >
                                                                Time to hire
                                                            </label>
                                                        </Col>
                                                        <Col xl={9}>

                                                            <input type="number"

                                                                // value={timetohire}
                                                                // onChange={(e) => settimetohire(e.value)}
                                                                className="w-full activejobdrop form-control"
                                                                readOnly
                                                                {...register("timetohire", {
                                                                    // required: "This field is required",
                                                                    pattern: {
                                                                        value: /^[0-9]*$/,
                                                                        message: "Please enter valid Time to hire ",
                                                                    },
                                                                    minLength: {
                                                                        value: 1,
                                                                        message: " Please enter valid Time to hire",
                                                                    },
                                                                    maxLength: {
                                                                        value: 5,
                                                                        message: "Please enter valid Time to hire maximum 5",
                                                                    }
                                                                })}
                                                                onKeyUp={() => { trigger("timetohire"); seterrorjobs("") }}
                                                            />
                                                            {errors.timetohire && (<small id='emailHelp' className='form-text text-danger'>{errors.timetohire.message}</small>)}

                                                        </Col>
                                                    </Row>
                                                    {/* <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label
                                                                htmlFor="integer"
                                                                className=" block"
                                                            >
                                                                Actual End date
                                                            </label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <Calendar
                                                                value={jobActualEnddate}
                                                                onChange={(e) => setjobActualEnddate(e.value)}
                                                                minDate={getMinEndDate()}
                                                                disabled={!jobStartDate}
                                                                dateFormat="yyyy-mm-dd"
                                                                placeholder="YYYY-MM-DD"
                                                                className="w-full activejobdrop"
                                                                showIcon
                                                            />
                                                        </Col>
                                                    </Row> */}



                                                    {/* <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="job_posting_date">Job Start Date</label>
                                                        </Col>
                                                        <Col xl={9}>



                                                            <Calendar
                                                                inputId="job_posting_date"
                                                                className="w-full"
                                                                value={getValues("job_posting_date")}
                                                                onChange={(e) => setValue("job_posting_date", e.value)}
                                                                onBlur={() => trigger("job_posting_date")}
                                                            />
                                                            {errors.job_posting_date && (
                                                                <small className="form-text text-danger">{errors.job_posting_date.message}</small>
                                                            )}
                                                        </Col>
                                                    </Row> */}

                                                    {/* <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="job_closing_date">Job End Date</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <Calendar
                                                                inputId="job_closing_date"
                                                                className="w-full"
                                                                value={getValues("job_closing_date")}
                                                                onChange={(e) => setValue("job_closing_date", e.value)}
                                                                onBlur={() => trigger("job_closing_date")}
                                                            />
                                                            {errors.job_closing_date && (
                                                                <small className="form-text text-danger">{errors.job_closing_date.message}</small>
                                                            )}
                                                        </Col>
                                                    </Row> */}

                                                    {/* <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label htmlFor="jobType">Private</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            <input
                                                                type="checkbox"
                                                                id="isPrivate"
                                                                className="me-2"
                                                                {...register("isPrivate")}
                                                                onChange={(e) => setValue("isPrivate", e.target.checked)}
                                                            />
                                                        </Col>
                                                    </Row> */}

                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>


                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Hiring Details</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12} >
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="hiringManager" className="block mb-2">
                                                                        Hiring Manager <span className="text-danger">*</span>
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <Dropdown value={hiringManager} onChange={(e) => { setHiringManager(e.value); setHiringManagerError(""); }} options={hiringManagers} optionLabel="name" optionValue="id" placeholder="Select Hiring Manager" filter filterPlaceholder="Search Hiring Manager" className="w-full activejobdrop" showClear={!!hiringManager} />
                                                                    </div>
                                                                    <small className="text-danger">{hiringManagerError}</small>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="recruiterManager" className="block mb-2">
                                                                        Recruiter Manager <span className="text-danger">*</span>
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <Dropdown value={recruiterManager} onChange={(e) => { setRecruiterManager(e.value); seterrmsgrecruitermanager(""); }} options={recruiterManagerOptions} optionLabel="name" optionValue="id" placeholder="Select Recruiter Manager" filter filterPlaceholder="Search Recruiter Manager" className="w-full activejobdrop" showClear={!!recruiterManager} />
                                                                    </div>
                                                                    <small className="text-danger">{errmsgrecruitermanager}</small>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="recruiters" className="block mb-2">
                                                                        Recruiters
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <MultiSelect value={recruiters} onChange={(e) => { setRecruiters(e.value); seterrmsgrecruiters(""); }} options={recruiterOptions} optionLabel="name" optionValue="id" placeholder="Select Recruiters" filter filterPlaceholder="Search Recruiters" className="w-full activejobdrop" />
                                                                    </div>
                                                                    <small className="text-danger">{errmsgrecruiters}</small>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="integer"
                                                                        className=" block mb-2"
                                                                    >
                                                                        Company <span className="text-danger">*</span>
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <Dropdown
                                                                            id="company"
                                                                            value={selectedCompany} // This binds the selected company id
                                                                            options={companies} // This binds the companies array
                                                                            onChange={(e) => setSelectedCompany(e.value)} // Update the selected company id
                                                                            placeholder="Select Company"
                                                                            optionLabel="name" // Display company name
                                                                            optionValue="id"  // Use company id as the value for selection
                                                                            filter // Enable search functionality
                                                                            filterBy="name" // Search by company name
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="integer"
                                                                        className=" block mb-2"
                                                                    >
                                                                        Job location
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <Dropdown
                                                                            value={jobLocation}
                                                                            onChange={(e) => setJobLocation(e.value)}
                                                                            options={jobLocations}
                                                                            optionLabel="name"
                                                                            optionValue="id"
                                                                            filter
                                                                            filterPlaceholder="Search Location"
                                                                            className="w-full activejobdrop"
                                                                            placeholder="Enter job location..."
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="employeeType"
                                                                        className="block mb-2"
                                                                    >
                                                                        Workplace Type
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <Dropdown
                                                                            id="jobLocation"
                                                                            value={jobworkspace}
                                                                            onChange={(e) => setjobworkspace(e.value)}
                                                                            options={jobworkspaceview}
                                                                            optionLabel="name"
                                                                            optionValue="id"
                                                                            filter
                                                                            filterPlaceholder="Search Location"
                                                                            className="w-full activejobdrop"
                                                                            placeholder="Enter Workplace Type..."
                                                                        />

                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="employeeType"
                                                                        className="block mb-2"
                                                                    >
                                                                        Job Type<span className="text-danger">*</span>
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <Dropdown
                                                                            value={jobtype}
                                                                            onChange={(e) => { setjobtypeerr(""); setjobtype(e.target.value) }}
                                                                            options={jobjobtypeview}
                                                                            placeholder="Select Job Type"
                                                                            optionLabel="name"
                                                                            optionValue="id"
                                                                            filter
                                                                            filterPlaceholder="Search Location"
                                                                            className="w-full activejobdrop"

                                                                        />

                                                                        {/* <Dropdown
                                                                            value={jobType}
                                                                            onChange={(e) => setJobType(e.value)}
                                                                            options={jobTypeOptions}
                                                                            optionLabel="name"
                                                                            placeholder="Select Job Type"
                                                                            className="w-full"
                                                                            filter
                                                                            filterBy="label"
                                                                        /> */}
                                                                    </div> <small className='form-text text-danger'>{jobtypeerr}</small>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="minSalary" className="block mb-2">
                                                                        Min Salary
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputNumber
                                                                        inputId="minSalary"
                                                                        value={minSalary}
                                                                        onValueChange={(e) => setMinSalary(e.value)}
                                                                        mode="currency"
                                                                        currency="INR"
                                                                        locale="en-IN"
                                                                        placeholder="Min Salary"
                                                                        min={0}
                                                                        className="w-full"
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="maxSalary" className="block mb-2">
                                                                        Max Salary
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputNumber
                                                                        inputId="maxSalary"
                                                                        value={maxSalary}
                                                                        onValueChange={(e) => setMaxSalary(e.value)}
                                                                        mode="currency"
                                                                        currency="INR"
                                                                        locale="en-IN"
                                                                        placeholder="Max Salary"
                                                                        min={0}
                                                                        className="w-full"
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="employeeType"
                                                                        className="block mb-2"
                                                                    >
                                                                        Department
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="card flex justify-content-center mb-0">
                                                                        <Dropdown

                                                                            value={departitemsval}
                                                                            onChange={(e) => setdepartitemsval(e.target.value)}
                                                                            options={departitems}
                                                                            placeholder="Select Department"
                                                                            optionLabel="name"
                                                                            optionValue="id"
                                                                            filter
                                                                            filterPlaceholder="Search Location"
                                                                            className="w-full activejobdrop"

                                                                        />
                                                                        {/* <select
                                                                            className='form-select profileDetailsInput' id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                                                                            aria-label='Default select example'

                                                                            {...register("department", {
                                                                                // required: "This field is required",
                                                                            })}>
                                                                            <option value=''>--Select --</option>
                                                                            {departitems.map((item, j) => {
                                                                                return (
                                                                                    <option value={item.department_id} key={j}>
                                                                                        {item.name}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </select> */}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        className=" block"
                                                                    >
                                                                        Category
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <TreeSelect
                                                                        value={selectedCategoryKey} // Bind the category ID
                                                                        onChange={handleCategoryChange}
                                                                        options={categoriesitem}
                                                                        optionLabel="name"
                                                                        optionValue="id" // Set the value as the category ID
                                                                        className="w-full"
                                                                        placeholder="Select Category"
                                                                        filter
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        className=" block"
                                                                    >
                                                                        Group
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <TreeSelect
                                                                        value={selectedGroupKey}
                                                                        onChange={(e) => setSelectedGroupKey(e.value)}
                                                                        options={groupitem}
                                                                        optionLabel="name"
                                                                        optionValue="id"
                                                                        filter
                                                                        className="w-full"
                                                                        placeholder="Select Group"
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            {/* <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="employeeType"
                                                                        className="block mb-2"
                                                                    >
                                                                        Categories
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>


                                                                    <TreeSelect
                                                                        filter
                                                                        className="w-full"
                                                                        placeholder="Select Category"
                                                                    ></TreeSelect>

                                                                </Col>
                                                            </Row> */}
                                                            {/* <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="employeeType"
                                                                        className="block mb-2"
                                                                    >
                                                                        Groups
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>

                                                                    <TreeSelect
                                                                        filter
                                                                        className="w-full"
                                                                        placeholder="Select Groups"
                                                                    ></TreeSelect>

                                                                </Col>
                                                            </Row> */}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>


                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">System Fields</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12}>



                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="integer"
                                                                        className=" block"
                                                                    >
                                                                        Create Date
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        id="jobStartDate"
                                                                        value={jobCreate}
                                                                        onChange={(e) => setjobCreate(e.value)}
                                                                        dateFormat="yy-mm-dd"
                                                                        placeholder="YYYY-MM-DD"
                                                                        className="w-full activejobdrop"
                                                                        showIcon
                                                                        icon="pi pi-calendar"
                                                                        disabled
                                                                    />

                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="integer"
                                                                        className=" block"
                                                                    >
                                                                        Edit Date
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        disabled
                                                                        value={editDatejob}
                                                                        onChange={(e) => seteditDatejob(e.value)}
                                                                        dateFormat="yy-mm-dd"
                                                                        placeholder="YYYY-MM-DD"
                                                                        className="w-full activejobdrop"
                                                                        showIcon
                                                                        icon="pi pi-calendar"
                                                                    />

                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label
                                                                        htmlFor="integer"
                                                                        className=" block"
                                                                    >
                                                                        Created By
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText

                                                                        className="w-full"
                                                                        disabled
                                                                        value={createdBy}
                                                                        onChange={(e) => setcreatedBy(e.value)}
                                                                    />
                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>

                            </Col>


                            {/* 2nd Row */}

                            <Col xl={8}>
                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">Job Description</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">

                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="primarySkills" className="mb-0">Primary Skills</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="p-field mb-0">
                                                                        <MultiSelect
                                                                            // style={{ border: "1px solid #ced4da", borderRadius: "5px", }}
                                                                            // id="multiSelect"
                                                                            className="w-full"
                                                                            options={skillsOptions}
                                                                            value={selectedprimarySkills}
                                                                            onChange={e => { setselectedprimarySkills(e.value) }}
                                                                            optionLabel="name"
                                                                            optionValue="id"
                                                                            placeholder="Select skills"
                                                                            filter
                                                                            display="chip" // Displays selected options as chips
                                                                        />

                                                                        {/* <Select
                                                                            options={primarySkillsget}
                                                                            optionLabel="name"
                                                                            optionValue="id"
                                                                            isMulti
                                                                            value={primarySkillsview.filter(option => selectedPrimarySkills.includes(option.value))}
                                                                            onChange={handlePrimarySkillsChange}
                                                                            placeholder="HTML, CSS, Javascript"
                                                                        /> */}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label htmlFor="secondarySkills" className="mb-0">Secondary Skills</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="p-field mb-0">
                                                                        <MultiSelect
                                                                            // style={{ border: "1px solid #ced4da", borderRadius: "5px", }}
                                                                            // id="multiSelect"
                                                                            className="w-full"
                                                                            options={skillsOptions}
                                                                            value={selectedSkillsSecondary}
                                                                            onChange={e => { setselectedSkillsSecondary(e.value) }}
                                                                            optionLabel="name"
                                                                            optionValue="id"
                                                                            filter
                                                                            placeholder="Select skills"
                                                                            display="chip" // Displays selected options as chips
                                                                        />
                                                                        {/* <Select
                                                                            id="secondarySkills"
                                                                            name="secondarySkills"
                                                                            isMulti
                                                                            options={skillsOptions}
                                                                            // value={skillsOptions.filter(option => selectedSecondarySkills.includes(option.value))}
                                                                            onChange={handleSecondarySkillsChange}
                                                                            placeholder="React JS"
                                                                        /> */}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className="mb-0">Job Function</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="p-field mb-0 card">
                                                                        <Dropdown
                                                                            value={selectedJobFunction}
                                                                            onChange={(e) => setSelectedJobFunction(e.value)}
                                                                            options={jobFunctions}
                                                                            optionLabel="name"
                                                                            optionValue="id"
                                                                            placeholder=" Enter Job Function"
                                                                            className="w-full"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label className="mb-0">Seniority</label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <div className="p-field mb-0 card">
                                                                        <Dropdown
                                                                            value={selectedSeniority}
                                                                            onChange={(e) => setSelectedSeniority(e.value)}
                                                                            options={seniorityLevels}
                                                                            optionLabel="name"
                                                                            optionValue="id"
                                                                            placeholder="Mid-Level"
                                                                            className="w-full"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="sidebar d-flex align-items-center">
                                                                <Col xl={6}>
                                                                    <label
                                                                        htmlFor="integer"
                                                                        className=" block mb-2"
                                                                    >
                                                                        Description
                                                                    </label>

                                                                </Col>
                                                                <Col lg={6} className="d-flex justify-content-end mt-2">
                                                                    <Button color="primary" className="btn btn-primary aibtn">
                                                                        <i class="pi pi-star me-1"></i>
                                                                        Write with AI
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mt-2 align-items-center">

                                                                <Col xl={12} className="mt-2">
                                                                    <div className="w-full">
                                                                        <Editor value={text} onTextChange={(e) => setText(e.htmlValue)} style={{ height: '200px' }}
                                                                        // {...register("Description", {
                                                                        //     required: "This field is required",
                                                                        //     // pattern: {
                                                                        //     //     value: /^[a-zA-Z_ ]*$/,
                                                                        //     //     message:
                                                                        //     //         "Please enter valid Job Tittle ",
                                                                        //     // },
                                                                        // })}
                                                                        // onKeyUp={() => { trigger("Description") }}
                                                                        />
                                                                        {/* {errors.Description && (<small id='emailHelp' className='form-text text-danger'>{errors.Description.message}</small>)} */}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            {/* <Row>
                                                                <Col>
                                                                    <div className="p-field">
                                                                        <label htmlFor="jobType" className="block">
                                                                            Notes
                                                                        </label>
                                                                        <InputTextarea
                                                                            autoResize
                                                                            value={description}
                                                                            onChange={e => setDescription(e.target.value)}
                                                                            rows={5}
                                                                            cols={40}
                                                                            placeholder=""
                                                                            className="w-full "
                                                                        />
                                                                    </div> </Col>
                                                            </Row> */}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>

                                <Card className="bg-form screening-que">
                                    <CardBody>
                                        <h4 className="card-title mb-3">Screening Questions</h4>
                                        <p>We suggest including at least three questions. Applicants are required to answer all questions.</p>
                                        {/* <DataTable rows={5} value={questionsData} showGridlines
                                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}">
                                        <Column field="question" header="Skill"></Column>
                                        <Column field="answer" header="Years of experience"></Column>
                                        <Column field="qualificationRequired" header="Must Have Qualification" style={{ width: '12vw' }}></Column>
                                    </DataTable> */}

                                        {/* <div className="block d-flex align-items-center justify-content-end">
                                        <a color="primary" className="anchr-title mt-3">
                                            <i className="pi pi-plus me-1"></i> Add Questions
                                        </a>
                                    </div>

                                    <div class="add-que-card">
                                    <p>How many years of experience do you have with [skill]?</p>
                                        <Row className="mb-2">
                                            <Col xl={4}>
                                                <label htmlFor="question" className="block">
                                                    Skill
                                                </label>
                                                <InputText
                                                    id="question"
                                                    value={question}
                                                    onChange={(e) => setQuestion(e.target.value)}
                                                    className="w-full"
                                                />
                                            </Col>
                                            <Col xl={4}>
                                                <label htmlFor="answer" className="block">
                                                    Years of experience
                                                </label>
                                                <InputText
                                                    id="answer"
                                                    value={answer}
                                                    onChange={(e) => setAnswer(e.target.value)}
                                                    className="w-full"
                                                />
                                            </Col>
                                            <Col xl={4}>
                                                <div className="d-flex">
                                                    <Checkbox
                                                        inputId="qualification"
                                                        onChange={e => setIsQualificationRequired(e.checked)}
                                                        checked={isQualificationRequired}
                                                    />
                                                    <label htmlFor="qualification" className="block mb-2 ms-2">Must Have Qualification</label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div> */}




                                        <div>
                                            <div className="block d-flex align-items-center justify-content-end">
                                                {/* <a
                                                    color="primary"
                                                    className="anchr-title mb-2"
                                                    onClick={handleAddQuestion}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <i className="pi pi-plus me-1"></i> Add Questions
                                                </a> */}
                                                <button type='button' className='btn addNewDeptBtn btn-outline-primary waves-effect' id='addNewDesigantionNameBtn' onClick={() => addFormFields()}>
                                                    <span> <i className='fa fa-plus mr-2' aria-hidden='true'></i>
                                                        Add Question
                                                        
                                                    </span>
                                                    <small className='addBtnText'> </small>
                                                </button>
                                            </div>

                                            {/* Render dynamic question cards */}

                                            {formValues.map((question, index) => (
                                                question.is_deleted === false && (
                                                    <div className="mb-2" key={index}>
                                                        <label htmlFor={`question-${index}`} className="form-field-label">
                                                            Question
                                                            <InputText
                                                                className={`form-control ${question.haveError && "invalid"}`}
                                                                value={question.section1}
                                                                onChange={(e) => handleChange(index, "section1", e.target.value)}
                                                            />
                                                        </label>
                                                        <Row className="mb-3">
                                                            <Col xl={4}>
                                                                <label htmlFor={`skill-${index}`} className="block">
                                                                    Skill <span className="text-danger">*</span>
                                                                </label>
                                                                <InputText
                                                                    className={`form-control ${question.haveError && "is-invalid"}`}
                                                                    value={question.skills}
                                                                    onChange={(e) => handleChange(index, "skills", e.target.value)}
                                                                    placeholder="Enter skill"
                                                                />
                                                            </Col>
                                                            <Col xl={4}>
                                                                <label htmlFor={`idealAnswer-${index}`} className="block">
                                                                    Ideal Answer (Minimum)
                                                                </label>
                                                                <InputText
                                                                    className={`form-control ${question.haveError && "is-invalid"}`}
                                                                    value={question.idealAnswer}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        // Allow alphabets, numbers, and special characters . , &
                                                                        if (/^[a-zA-Z0-9.,&]*$/.test(value)) {
                                                                            handleChange(index, "idealAnswer", value);
                                                                        }
                                                                    }}
                                                                    placeholder="Enter ideal answer"
                                                                />
                                                            </Col>
                                                            <Col xl={4}>
                                                                <div className="d-flex align-items-center mt-4">
                                                                    <Checkbox
                                                                        inputId={`qualification-${index}`}
                                                                        checked={question.qualification}
                                                                        onChange={(e) => handleChange(index, "qualification", e.checked)}
                                                                    />
                                                                    <label htmlFor={`qualification-${index}`} className="ms-2 mt-1">
                                                                        Must Have Qualification
                                                                    </label>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <div className="d-flex justify-content-end">
                                                            <Button
                                                                icon="pi pi-times"
                                                                className="p-button-danger"
                                                                onClick={() => removeFormFields(index, formValues[index].question_id)}
                                                            >
                                                                Remove
                                                            </Button>
                                                        </div>
                                                        {question.haveError && <small className="text-danger">{questionError}</small>}
                                                    </div>
                                                )
                                            ))}


                                        </div>

                                        {/* <Dialog
                                        header="Screening Questions"
                                        visible={queVisible}
                                        onHide={() => setQueVisible(false)}
                                        style={{ width: '30vw' }}
                                        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                    >

                                        <p>How many years of experience do you have with [skill]?</p>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="question" className="block">
                                                    Skill
                                                </label>
                                                <InputText
                                                    id="question"
                                                    value={question}
                                                    onChange={(e) => setQuestion(e.target.value)}
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="answer" className="block">
                                                    Years of experience
                                                </label>
                                                <InputText
                                                    id="answer"
                                                    value={answer}
                                                    onChange={(e) => setAnswer(e.target.value)}
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <div className="d-flex">
                                                    <Checkbox
                                                        inputId="qualification"
                                                        onChange={e => setIsQualificationRequired(e.checked)}
                                                        checked={isQualificationRequired}
                                                    />
                                                    <label htmlFor="qualification" className="block mb-2 ms-2">Must Have Qualification</label>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row className="align-items-center mt-3">
                                            <Col md={12}>
                                                <div className="d-flex justify-content-end">
                                                    <button type="button" className="btn btn-primary btn-main me-2" onClick={handleCreate}>
                                                        Create
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Dialog> */}

                                        <ConfirmDialog />
                                    </CardBody>
                                </Card>


                            </Col>



                            {/* 3rd Row */}

                            {/* <Col xl={4}>

                           


                        </Col> */}
                        </Row >
                        <small className='form-text text-danger'>{errorjobs}</small>


                        <Row className="align-items-center mb-3">

                            <Col md={12}>
                                <div className="d-flex justify-content-end">

                                    <button type="submit" class="btn btn-success me-2">  <i className="pi pi-save me-1"></i>Save</button>


                                    <Link to="/allactive-jobs">
                                        <Button
                                            color="primary"
                                            className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"

                                        >
                                            <i className="pi pi-times me-1"></i>
                                            Cancel
                                        </Button>
                                    </Link>
                                </div>

                            </Col>
                        </Row>
                    </form>
                </Container >
            </div >
        </React.Fragment >
    )
}

export default JobsEditForm;
